<template>
  <header class="navbar">
    <div class="navbar-brand"><img src="@/assets/img/logo.png" class="my-auto d-block ml-4" height="32" /></div>
    <!-- 可以添加更多导航内容 -->
  </header>
</template>

<script>
export default {
  name: 'NavBar'
}
</script>

<style scoped>
.navbar {
  background-color: #2c3e50;
  color: white;
  padding: 1rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.navbar-brand {
  font-size: 1.5rem;
  font-weight: bold;
}
</style>